
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ar/video",
      function () {
        return require("private-next-pages/ar/video.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ar/video"])
      });
    }
  